import { Card, CardContent, CardHeader, CardTitle } from '../../../../../components/ui/card';
import type { AuditHistoryEntry } from '../../../../../infrastructure/OMSClient';
import { formatUnixTimestampToUTC, formatUnixTimestampToLocal } from '../../../../../utils/dateUtils';

interface AuditEntryProps {
  entry: AuditHistoryEntry;
}

export function AuditEntry({ entry }: AuditEntryProps) {
  return (
    <Card className="mb-4">
      <CardHeader className="py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div>
              <CardTitle className="text-sm font-medium">
                <span className="">{entry.source}</span>
                {entry.operator && (
                  <span className="ml-2 text-sm font-normal">
                    : <code className="font-normal text-blue-600">{entry.operator}</code>
                  </span>
                )}
              </CardTitle>
            </div>
          </div>
        </div>
      </CardHeader>
      <CardContent className="py-2">
        <div className="space-y-3">
          {/* Display other updated data */}
          {Object.keys(entry.updatedData).filter((key) => key !== 'auditEntry').length > 0 && (
            <div className="border border-gray-200 rounded p-3">
              <code className="font-normal">{entry.operation?.toUpperCase()}</code> <br></br>
              <div className="flex items-center gap-1 text-sm text-muted-foreground">
                {formatUnixTimestampToUTC(entry.updatedTimestamp)}
              </div>
              <div className="flex items-center gap-1 text-sm text-muted-foreground">
                {formatUnixTimestampToLocal(entry.updatedTimestamp)}
              </div>
              <hr></hr>
              <div className="p-1 rounded">
                <pre className="text-xs text-gray-700 whitespace-pre-wrap overflow-x-auto">
                  {JSON.stringify(
                    Object.fromEntries(Object.entries(entry.updatedData).filter(([key]) => key !== 'auditEntry')),
                    null,
                    2,
                  )}
                </pre>
              </div>
            </div>
          )}

          {/* If only audit entry (no actual changes) */}
          {Object.keys(entry.updatedData).length === 1 && entry.updatedData.auditEntry && (
            <div className="text-sm text-muted-foreground italic">No data changes - audit entry only</div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
